import { Component, input, output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "portal-content-panel",
  templateUrl: "./content-panel.component.html",
  styleUrls: ["./content-panel.component.scss"],
  standalone: true,
  imports: [TranslatePipe],
})
export class ContentPanelComponent {
  readonly headerTitle = input("");
  readonly productImageUrl = input("");
  readonly productNameTitle = input("");
  readonly headerImageUrl = input("");
  readonly buttonDisabled = input(false);
  readonly button2Disabled = input(false);

  readonly footerUrl = input("");
  readonly footerUrlText = input("");
  readonly footerButtonText = input("");
  readonly footerButton2Text = input("");

  readonly footerButtonClick = output<void>();
  readonly footerButton2Click = output<void>();

  footerButtonClicked(): void {
    this.footerButtonClick.emit();
  }

  footerButton2Clicked(): void {
    this.footerButton2Click.emit();
  }
}
